<template>
    <div v-editable="blok">
        <b-form-group
            :label="blok.label"
        >
            <FormInput
                pattern="^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$"
                name="postal"
                :required="blok.required"
                autocomplete="postal-code"
                placeholder="e.g. E14 2JW"
                v-model="value"
                ></FormInput>
        </b-form-group>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import FormInput from "@/components/form/FormInput";

export default {
    name: 'profile-postcode',
    props: {
        blok: Object
    },
    components: {
        FormInput
    },
    computed: {
        ...mapState({
            user: state => state.profile.user
        }),
        value: {
            get: function() {
                return this.user.postcode;
            },
            set: function(value) {
                this.updatePostCode(value);
            }
        }
    },
    methods: {
        ...mapActions("profile", ["updatePostCode"])
    }
}
</script>